import SimpleModal from '@/ui/SimpleModal';
import type { CSSProperties } from 'react';
import type { ModalElementProps } from './ModalElement.types.js';

export function ModalElement({
  isOpen,
  onOpenChange,
  isLoading,
  children,
  showCloseButton,
  hideOverflow,
}: ModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={(open: boolean) => {
        if (!isLoading) {
          onOpenChange?.(open);
        }
      }}
      className="shadow-lg overflow-hidden sm:rounded-md"
      style={generatedStyle}
      showRoundedBorders={false}
      showCloseButton={showCloseButton}
      shouldCloseOnOutsideClick={!isLoading}
      hideOverflow={hideOverflow}
    >
      {children}
    </SimpleModal>
  );
}
